/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconOvalVertical = createReactComponent("outline", "oval-vertical", "IconOvalVertical", [["path", { "d": "M3 12c0 -3.314 4.03 -6 9 -6s9 2.686 9 6s-4.03 6 -9 6s-9 -2.686 -9 -6z", "key": "svg-0" }]]);

export { IconOvalVertical as default };
//# sourceMappingURL=IconOvalVertical.mjs.map
